import { t } from "@lingui/macro";

import { i18n } from "@base/common/libs/i18n/index.js";

window.isUserOffline = false;
let intervalId;
let isRequestTimeExceeded = false;
let interceptors = [];
const OFFLINE_REQUESTS = [];

let screenResoluionValue = window.screen.width + "x" + window.screen.height;
let browserViewportResolution = window.innerWidth + "x" + window.innerHeight;

window.addEventListener("online", function offlineHanlder(e) {
  window.isUserOffline = false;
  clearTimeout(intervalId);
  if (isRequestTimeExceeded) {
    Interceptor.rejectPendingRequest();
    isRequestTimeExceeded = false;
  } else {
    Interceptor.resolvePendingRequest();
  }
});

window.addEventListener("offline", function offlineHanlder(e) {
  window.isUserOffline = true;
  intervalId = setTimeout(() => {
    isRequestTimeExceeded = true;
    Interceptor.rejectPendingRequest();
  }, 6000);
});

// eslint-disable-next-line kf/const-naming-convention
export const Interceptor = {
  addInterceptor(interceptor) {
    interceptors.push(interceptor);
  },

  fetch(requestObject) {
    // NOTE: if any headers added here, inform backend team to add in ID API CORS
    requestObject.headers.set("Content-Type", "application/json");
    requestObject.headers.set("X-Screen-Resolution", screenResoluionValue);
    requestObject.headers.set(
      "X-Viewport-Resolution",
      browserViewportResolution
    );

    let request = interceptors.reduce((requestObject, interceptor) => {
      if (interceptor.request) {
        requestObject = interceptor.request(requestObject);
      }
      return requestObject;
    }, requestObject);

    if (window.isUserOffline) {
      return createOfflineRequest(request);
    } else {
      let promise = fetch(request);

      interceptors.forEach((interceptor) => {
        if (interceptor?.response || interceptor?.responseError) {
          promise = promise.then(
            interceptor?.response,
            interceptor?.responseError
          );
        }
      });
      return promise;
    }
  },

  resolvePendingRequest() {
    for (let { resolveRequest } of OFFLINE_REQUESTS) {
      resolveRequest();
    }
    OFFLINE_REQUESTS.length = 0;
  },

  rejectPendingRequest() {
    for (let { rejectRequest } of OFFLINE_REQUESTS) {
      rejectRequest();
    }
    OFFLINE_REQUESTS.length = 0;
  }
};

const createOfflineRequest = async (request) => {
  const offlineMessage = t`Looks like your network connection is unstable. Some actions might fail.`;

  const pendingPromise = new Promise((resolve, reject) => {
    OFFLINE_REQUESTS.push({
      resolveRequest: () => {
        return fetch(request)
          .then((res) => res.json())
          .then((data) => resolve(data));
      },
      rejectRequest: () =>
        reject({
          name: "Offline",
          message: i18n._(offlineMessage)
        })
    });
  });

  return pendingPromise;
};
